import { colors, spacing, fonts } from '../../tokens';
export default {
  wrapper: {
    padding: "0 ".concat(spacing.xs),
    borderRadius: spacing.xs,
    backgroundColor: '#F6EBFF',
    fonts: fonts.xs,
    fontFamily: '"Metropolis-SemiBold", sans-serif',
    color: colors.brand.primary
  },
  closeButton: {
    marginLeft: spacing.s,
    iconColor: colors.brand.primary,
    iconSize: spacing.s
  }
};